import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

type ToastType = 'success' | 'info' | 'warning' | 'error';

@Injectable({ providedIn: 'root' })
export class ToasterService {

  private readonly defaultDuration = 5000;
  private readonly defaultErrorDuration = 10000;
  private readonly colors: Record<ToastType, string> = {
    success: '#25cc7b',
    info: '#168fce',
    warning: '#b77909',
    error: '#fa6a6f'
  };

  public clear(): void {
    if (Swal.getPopup()?.classList.contains('app-swal-toast')) {
      Swal.close();
    }
  }

  public success(message: string): void {
    this.show(message, 'success');
  }

  public info(message: string): void {
    this.show(message, 'info');
  }

  public warning(message: string): void {
    this.show(message, 'warning');
  }

  public error(message: string): void {
    this.show(message, 'error');
  }

  private show(message: string, type: ToastType): void {
    void Swal.fire({
      toast: true,
      position: 'top-end',
      titleText: message,
      icon: type,
      iconColor: '#fff',
      ...(type === 'success' ? {
        iconHtml: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="m4 12 5 5L20 6" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      } : {}),
      background: this.colors[type],
      color: '#fff',
      showConfirmButton: false,
      showCloseButton: true,
      closeButtonAriaLabel: 'Dismiss notification',
      timer: type === 'error' ? this.defaultErrorDuration : this.defaultDuration,
      timerProgressBar: true,
      customClass: {
        popup: 'app-swal-toast',
        icon: type === 'success' ? 'app-swal-toast-check' : ''
      },
      didOpen: popup => {
        popup.addEventListener('mouseenter', () => Swal.stopTimer());
        popup.addEventListener('mouseleave', () => Swal.resumeTimer());
        popup.addEventListener('focusin', () => Swal.stopTimer());
        popup.addEventListener('focusout', () => Swal.resumeTimer());
      }
    });
  }
}
